import Vue from 'vue'
import axios from 'axios'
import router from '../router'


// let baseURL = 'http://192.168.1.53:5068/api'
let baseURL = 'https://tg1.chacewang.com/api'
// let baseURL = '/api'

axios.defaults.crossDomain = true;
axios.defaults.withCredentials = false

axios.defaults.baseURL = baseURL

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  let token = window.localStorage.getItem("token")
  if (!config.headers.hasOwnProperty('ApiToken') && token) {
    config.headers.ApiToken = token;
    window.localStorage.setItem("isToken", true);
  } else {
    window.localStorage.setItem("isToken", false);
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response && response.data) {
      let datas = response.data
      let dataArr = datas.data
      if(datas.success === false && dataArr.IsLogin === false) {
        //  清除token信息并跳转到登录页面
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("isToken");
        let fullPath = router.currentRoute.fullPath;
        if(fullPath.indexOf("/Login?redirect=")==0){
          fullPath = fullPath.substring(16)
        }
        fullPath = decodeURI(fullPath)
        router.replace({
          path: '/Login',
          query: { redirect: fullPath }
        })
      }
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  });

Vue.prototype.axios = axios

export default axios



// WEBPACK FOOTER //
// ./src/axios/index.js